var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgStartEvaluation = function SvgStartEvaluation(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.333,
    d: "M1.145.702a.332.332 0 0 0-.456.418l1.896 5.084c.111.3.111.63 0 .931L.69 12.22a.332.332 0 0 0 .455.418l12-5.667a.333.333 0 0 0 0-.603l-12-5.666Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgStartEvaluation);
export default ForwardRef;